import LoginForm from "@/components/forms/LoginForm";
import SignupForm from "@/components/forms/SignupForm";
import EmailConfigurationListPage from "@/pages/EmailConfiguration";
import AddEmailConfigurationPage from "@/pages/EmailConfiguration/AddEmailConfiguration";
import SMSConfigurationListPage from "@/pages/SMSConfiguration";
import AddSMSConfigurationPage from "@/pages/SMSConfiguration/AddSMSConfiguration";
import ImportAddPage from "@/pages/ImportManagement/ImportAddPage";
import ImportDetailPage from "@/pages/ImportManagement/ImportDetailPage";
import ImportListPage from "@/pages/ImportManagement/ImportListPage";
import LetterHeadListPage from "@/pages/LetterHead";
import AddLetterHeadPage from "@/pages/LetterHead/AddLetterHead";
import NotificationListPage from "@/pages/Notification";
import AddNotificationPage from "@/pages/Notification/AddNotificationPage";
import PrintFormatListPage from "@/pages/PrintFormat";
import AddPrintFormatPage from "@/pages/PrintFormat/AddPrintFormat";
import PrintPage from "@/pages/PrintPage";
import FromSchemasRenderPage from "@/pages/SchemaManagement/FromSchemasRenderPage";
import ModulePage from "@/pages/SchemaManagement/ModulePage";
import ModuleFormPage from "@/pages/SchemaManagement/ModulePage/ModuleFormPage";
import SchemasListPage from "@/pages/SchemaManagement/SchemasListPage";
import SchemaFormPage from "@/pages/SchemaManagement/SchemasListPage/SchemaFormPage";
import TranslationListPage from "@/pages/TranslationListPage";
import TranslationFormPage from "@/pages/TranslationListPage/TranslationFormPage";
import PermissionPage from "@/pages/UserManagement/PermissionPage";
import RoleListPage from "@/pages/UserManagement/RoleListPage";
import RoleFormPage from "@/pages/UserManagement/RoleListPage/RoleFormPage";
import UserListPage from "@/pages/UserManagement/UserListPage";
import ActionMasterListPage from "@/pages/Workflow/ActionMasterPage";
import ActionMasterFormPage from "@/pages/Workflow/ActionMasterPage/ActionMasterFormPage";
import StateMasterListPage from "@/pages/Workflow/StateMasterPage";
import StateMasterFormPage from "@/pages/Workflow/StateMasterPage/StateMasterFormPage";
import WorkflowListPage from "@/pages/Workflow/WorkflowPage";
import WorkflowFormPage from "@/pages/Workflow/WorkflowPage/WorkflowFormPage";
import navigationRoutes from "./navigationRoutes";
import UserFormPage from "@/pages/UserManagement/UserListPage/UserFormPage";
import SocialConfigurationListPage from "@/pages/SocialConfiguration";
import SocialConfigurationPage from "@/pages/SocialConfiguration/SocialConfigurationPage";
import UserPermissionsListPage from "@/pages/UserManagement/UserPermissions";
import UserPermissionsPage from "@/pages/UserManagement/UserPermissions/UserPermissionsPage";
import ForgotPasswordForm from "@/components/forms/ForgotPassword";
import ForgotPasswordResetForm from "@/components/forms/forgotPasswordReset";
import TenantProfilePage from "@/pages/TenantProfile/inde";
import NpsUserList from "@/pages/Nps/NpsUserList";
import SLAConfigurationListPage from "@/pages/SLAConfiguration";
import SLAFormPage from "@/pages/SLAConfiguration/SLA/SLAFormPage";
import SLASchemaConfigurationPage from "@/pages/SLAConfiguration/SLASchemaConfiguration";
import SLASchemaConfigurationListPage from "@/pages/SLAConfiguration/SLASchemaConfiguration/SLASchemaConfigurationListPage";

// Protected routes that require authentication
const protectedRoutes = [
  // Schema management
  {
    path: navigationRoutes.SCHEMAS,
    element: SchemasListPage,
    name: "Schemas",
  },
  {
    path: navigationRoutes.SCHEMA_ADD,
    element: SchemaFormPage,
    name: "Add Schema",
  },
  {
    path: navigationRoutes.SCHEMA_EDIT_ROUTE,
    element: SchemaFormPage,
    name: "Edit Schema",
  },
  {
    path: navigationRoutes.SCHEMA_RENDER_ROUTE,
    element: FromSchemasRenderPage,
    name: "Schema Render",
  },

  // Nps User List
  {
    path: navigationRoutes.NPS_USER_LIST,
    element: NpsUserList,
    name: "Nps User List",
  },

  // social configuration management
  {
    path: navigationRoutes.SOCIAL_CONFIGURATION,
    element: SocialConfigurationListPage,
    name: "Social Configuration",
  },

  {
    path: navigationRoutes.SOCIAL_CONFIGURATION_ADD,
    element: SocialConfigurationPage,
    name: "Add Social Configuration",
  },

  {
    path: navigationRoutes.SOCIAL_CONFIGURATION_EDIT_ROUTE,
    element: SocialConfigurationPage,
    name: "Edit Social Configuration",
  },

  // Tenant profile management

  {
    path: navigationRoutes.TENANT_PROFILE,
    element: TenantProfilePage,
    name: "Tenant Profile",
  },

  {
    path: navigationRoutes.TENANT_PROFILE_ADD,
    element: TenantProfilePage,
    name: "Add Tenant Profile",
  },

  {
    path: navigationRoutes.TENANT_PROFILE_EDIT_ROUTE,
    element: TenantProfilePage,
    name: "Edit Tenant Profile",
  },

  // User management
  {
    path: navigationRoutes.USERS,
    element: UserListPage,
    name: "Users",
  },
  {
    path: navigationRoutes.USER_EDIT_ROUTE,
    element: UserFormPage,
    name: "User Details",
  },
  {
    path: navigationRoutes.USER_ADD,
    element: UserFormPage,
    name: "Add User",
  },

  // Permission management
  {
    path: navigationRoutes.ROLES,
    element: RoleListPage,
    name: "Roles",
  },
  {
    path: navigationRoutes.ROLE_ADD,
    element: RoleFormPage,
    name: "Add Role",
  },
  {
    path: navigationRoutes.ROLE_EDIT_ROUTE,
    element: RoleFormPage,
    name: "Edit Role",
  },
  {
    path: navigationRoutes.PERMISSIONS,
    element: PermissionPage,
    name: "Permissions",
  },

  // Module management
  {
    path: navigationRoutes.MODULE_ROUTE,
    element: ModulePage,
    name: "Module",
  },
  {
    path: navigationRoutes.MODULE_ADD_ROUTE,
    element: ModuleFormPage,
    name: "Add Module",
  },
  {
    path: navigationRoutes.MODULE_EDIT_ROUTE,
    element: ModuleFormPage,
    name: "Edit Module",
  },

  // Workflow management
  {
    path: navigationRoutes.WORKFLOW_LIST,
    element: WorkflowListPage,
    name: "Workflows",
  },
  {
    path: navigationRoutes.WORKFLOW_ADD,
    element: WorkflowFormPage,
    name: "Add Workflow",
  },
  {
    path: navigationRoutes.WORKFLOW_EDIT_ROUTE,
    element: WorkflowFormPage,
    name: "Edit Workflow",
  },

  // Print Format
  {
    path: navigationRoutes.PRINT_FORMAT,
    element: PrintFormatListPage,
    name: "Print Format",
  },
  {
    path: navigationRoutes.PRINT_FORMAT_ADD,
    element: AddPrintFormatPage,
    name: "Add Print Format",
  },
  {
    path: navigationRoutes.PRINT_FORMAT_EDIT_ROUTE,
    element: AddPrintFormatPage,
    name: "Edit Print Format",
  },

  ///Letter Head

  {
    path: navigationRoutes.LETTER_HEAD,
    element: LetterHeadListPage,
    name: "Letter Head",
  },

  {
    path: navigationRoutes.LETTER_HEAD_ADD,
    element: AddLetterHeadPage,
    name: "Add Letter Head",
  },

  ///Notification
  {
    path: navigationRoutes.Notification,
    element: NotificationListPage,
    name: "Notification",
  },

  {
    path: navigationRoutes.Notification_ADD,
    element: AddNotificationPage,
    name: "Add Notification",
  },

  {
    path: `${navigationRoutes.Notification_ADD}/:id`,
    element: AddNotificationPage,
    name: "Edit Notification",
  },

  {
    path: navigationRoutes.LETTER_HEAD_EDIT_ROUTE,
    element: AddLetterHeadPage,
    name: "Edit Letter Head",
  },

  ///Email Configuration

  {
    path: navigationRoutes.EMAIL_CONFIGURATION,
    element: EmailConfigurationListPage,
    name: "Email Configuration",
  },
  {
    path: navigationRoutes.EMAIL_CONFIGURATION_ADD,
    element: AddEmailConfigurationPage,
    name: "Add Email Configuration",
  },
  {
    path: navigationRoutes.EMAIL_CONFIGURATION_EDIT_ROUTE,
    element: AddEmailConfigurationPage,
    name: "Edit Email Configuration",
  },
  // User Permissions
  {
    path: navigationRoutes.USER_PERMISSIONS,
    element: UserPermissionsListPage,
    name: "User Permissions",
  },
  {
    path: navigationRoutes.USER_PERMISSIONS_ADD,
    element: UserPermissionsPage,
    name: "Add User Permissions",
  },
  {
    path: navigationRoutes.USER_PERMISSIONS_EDIT_ROUTE,
    element: UserPermissionsPage,
    name: "Edit User Permissions",
  },

  ///SMS Configuration

  {
    path: navigationRoutes.SMS_CONFIGURATION,
    element: SMSConfigurationListPage,
    name: "SMS Configuration",
  },

  {
    path: navigationRoutes.SMS_CONFIGURATION_ADD,
    element: AddSMSConfigurationPage,
    name: "Add SMS Configuration",
  },

  {
    path: navigationRoutes.SMS_CONFIGURATION_EDIT_ROUTE,
    element: AddSMSConfigurationPage,
    name: "Edit SMS Configuration",
  },

  // State management
  {
    path: navigationRoutes.STATE_MASTERS,
    element: StateMasterListPage,
    name: "State Masters",
  },
  {
    path: navigationRoutes.STATE_MASTER_ADD,
    element: StateMasterFormPage,
    name: "Add State Master",
  },
  {
    path: navigationRoutes.STATE_MASTER_EDIT_ROUTE,
    element: StateMasterFormPage,
    name: "Edit State Master",
  },

  // Action management
  {
    path: navigationRoutes.ACTION_MASTERS,
    element: ActionMasterListPage,
    name: "Action Masters",
  },
  {
    path: navigationRoutes.ACTION_MASTER_ADD,
    element: ActionMasterFormPage,
    name: "Add Action Master",
  },
  {
    path: navigationRoutes.ACTION_MASTER_EDIT_ROUTE,
    element: ActionMasterFormPage,
    name: "Edit Action Master",
  },

  // SLA Configuration
  {
    path: navigationRoutes.SLA_CONFIGURATION,
    element: SLASchemaConfigurationListPage,
    name: "SLA Configuration",
  },
  {
    path: navigationRoutes.SLA_CONFIGURATION_ADD,
    element: SLASchemaConfigurationPage,
    name: "Add SLA Configuration",
  },
  {
    path: navigationRoutes.SLA_CONFIGURATIONS,
    element: SLAConfigurationListPage,
    name: "SLA Configurations",
  },
  {
    path: navigationRoutes.SLA_ADD,
    element: SLAFormPage,
    name: "Add SLA Configuration",
  },
  {
    path: navigationRoutes.SLA_EDIT_ROUTE,
    element: SLAFormPage,
    name: "Edit SLA Configuration",
  },

  // Translation management
  {
    path: navigationRoutes.TRANSLATIONS,
    element: TranslationListPage,
    name: "Translations",
  },
  {
    path: navigationRoutes.TRANSLATION_ADD,
    element: TranslationFormPage,
    name: "Add Translation",
  },
  {
    path: navigationRoutes.TRANSLATION_EDIT_ROUTE,
    element: TranslationFormPage,
    name: "Edit Translation",
  },

  // Import management
  {
    path: navigationRoutes.IMPORTS,
    element: ImportListPage,
    name: "Imports",
  },
  {
    path: navigationRoutes.IMPORT_ADD,
    element: ImportAddPage,
    name: "Add Import",
  },
  {
    path: navigationRoutes.IMPORT_DETAIL_ROUTE,
    element: ImportDetailPage,
    name: "Import Details",
  },

  // Print
  {
    path: navigationRoutes.PRINT_ROUTE,
    element: PrintPage,
    name: "Print",
  },
];

// Public routes that don't require authentication
const publicRoutes = [
  {
    path: navigationRoutes.LOGIN,
    element: LoginForm,
    name: "Login",
  },
  {
    path: navigationRoutes.SIGNUP,
    element: SignupForm,
    name: "Signup",
  },
  {
    path: navigationRoutes.FORGOT_PASSWORD,
    element: ForgotPasswordForm,
    name: "Forgot Password",
  },
  {
    path: navigationRoutes.FORGOT_PASSWORD_RESET_ROUTE,
    element: ForgotPasswordResetForm,
    name: "Forgot Password Reset",
  },
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: protectedRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
export { navigationRoutes };
